import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

export const styles = StyleSheet.create({
  selectorWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    borderBottom: `1px solid ${colour.grey[500]}`,
    left: -20,
    position: 'relative',
    width: 'calc(100% + 40px)',
    padding: '0 20px',
    marginBottom: 10
  },
  selectorPanel: {
    fontSize: 18,
    fontWeight: 600,
    color: colour.grey[400],
    padding: '3px 20px 0 0',
    textAlign: 'center',
    cursor: 'pointer'
  },
  selector: {
    paddingBottom: 10,
    marginBottom: 0,
    borderBottom: `3px solid transparent`
  },
  selected: {
    color: colour.grey[200],
    borderBottom: `3px solid ${colour.energy.primaryGradientTop}`
  }
});
